<div class="palantir-dropdown-menu">
  <palantir-text type="description">{{ label }}</palantir-text>

  <palantir-button
    layout="suffix"
    theme="transparent"
    icon="arrow-drop-down-outline"
    [cdkMenuTriggerFor]="menu"
    size="xs"
  >
    {{ selectedValue() }}
  </palantir-button>

  <ng-template #menu>
    <palantir-content class="palantir-menu palantir-dropdown-menu__menu palantir-scrollbar" cdkMenu>
      <ng-content select="[palantir-dropdown-item], palantir-dropdown-item" />
    </palantir-content>
  </ng-template>
</div>
